import { useMediaQuery, useTheme } from '@mui/material';

export const useDesktop = () => {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.up('sm'));
};
